import { render, staticRenderFns } from "./ProximasLicencasAVencer.vue?vue&type=template&id=02bc2e70&"
import script from "./ProximasLicencasAVencer.vue?vue&type=script&lang=js&"
export * from "./ProximasLicencasAVencer.vue?vue&type=script&lang=js&"
import style0 from "./ProximasLicencasAVencer.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VDivider,VRow})
